import {useEffect, useState} from 'react'

const queries = {
  xs: 575,
  sm: 767,
  md: 992,
  lg: 1200,
  xl: 1600,
  xxl: 2000,
}
const useMediaQueries = () => {
  const [screens, setScreens] = useState({})
  useEffect(() => {
    getWindowSize()
    window.addEventListener('resize', getWindowSize)
    return () => {
      window.removeEventListener('resize', getWindowSize)
    }
  }, [])
  function getWindowSize() {
    const {innerWidth} = window
    let breakPoint = {}
    const points = {xs: false, sm: false, md: false, lg: false, xl: false, xxl: false}
    if (innerWidth <= queries.xs) {
      breakPoint = {...points, xs: true}
    } else if (innerWidth > queries.xs && innerWidth <= queries.sm) {
      breakPoint = {...points, sm: true, xs: true}
    } else if (innerWidth > queries.sm && innerWidth <= queries.md) {
      breakPoint = {...points, md: true, sm: true, xs: true}
    } else if (innerWidth > queries.md && innerWidth <= queries.lg) {
      breakPoint = {...points, lg: true, md: true, sm: true, xs: true}
    } else if (innerWidth > queries.lg && innerWidth <= queries.xxl) {
      breakPoint = {...points, xl: true, lg: true, md: true, sm: true, xs: true}
    } else {
      breakPoint = {...points, xl: true, lg: true, xxl: true, md: true, sm: true, xs: true}
    }
    setScreens(breakPoint)
  }
  return screens
}
export default useMediaQueries
